import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../redux/store';
import GridItem from '../../../components/gridItem';
import GridItemSkeleton from '../../../components/gridItem/skeleton';
import EmptyList from '../../../components/emptyList';
import { TabWithCategories } from '../../../interfaces/api/chat/config';
import { routes } from '../../../config/routes';

const defaultImage = require("../../../assets/images/tabs/medicalUpdates.png");

type TabValue = 'clinical_cases' | string;

const images: Record<TabValue, any> = {
    'clinical_cases': require("../../../assets/images/tabs/clinicalCase.png"),
    'medical_reports': require("../../../assets/images/tabs/diagnosticTools.png"),
    'monitoringـdisease_progression': require("../../../assets/images/tabs/monitoringDiseaseProgression.png"),
    'functional_medicine_support': require('../../../assets/images/tabs/latestInnovations.png'),
    'personalized_genomics_analytics': require('../../../assets/images/tabs/personalizedGenomicsAnalytics.png'),
    'anomalies_detection': require('../../../assets/images/tabs/anomaliesDetection.png'),
    'diseases_prediction': require('../../../assets/images/tabs/diseasesPrediction.png'),
    'survival_analysis': require('../../../assets/images/tabs/latestInnovations.png'),
    'compare_your_case_with_similar': require('../../../assets/images/tabs/compareYourCaseWithSimilar.png'),
    'lifeguards_predicted_alerts': require('../../../assets/images/tabs/lifeguardsPredictedAlerts.png'),
    'early_stage_asymptomatic_diseas': require('../../../assets/images/tabs/earlyStageAsymptomaticDiseas.png'),
};

const GenioMD = () => {
  const navigate = useNavigate();
  const { categories, isLoadingCategories } = useSelector((state: RootState) => state.auth);

  const handleCardClick = (item: TabWithCategories) => {
    const tabId = item.tab_value?.replace(/_/g, '-');
    navigate(routes.genioMD.clinicalCase(tabId));
  };

  const getImageForTab = (tabValue: string) => {
    console.log(tabValue);
    return images[tabValue as TabValue] || defaultImage;
  };

  if (isLoadingCategories) {
    return (
      <div className="py-4">
        <div className="mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
            {Array.from({ length: 9 }).map((_, index) => (
              <GridItemSkeleton key={index} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!categories.length) {
    return (
      <EmptyList
        title="No Categories Available"
        description="There are no categories to display at the moment. Please try again later."
      />
    );
  }

  return (
    <div className="py-4">
      <div className="mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
          {categories.map((item: TabWithCategories) => (
            <GridItem
              key={item.id}
              id={item.id}
              tab_name={item.tab_name}
              imageUri={getImageForTab(item.tab_value?.trim())}
              onClick={() => handleCardClick(item)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GenioMD;